// 帳號管理
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
import Formatter from 'core/format';
import SideMenu from 'components/sideMenu';
import Button from 'components/button';
import DatePicker from 'components/datePicker';
import Table from 'components/table';
import Pagination from 'components/pagination/pagination';
import moment from 'moment';
import { search, getAccountBalancePDF, clearAccountList } from './action';
import './account.css';

class AccountIndex extends Component {
  constructor(props) {
    super(props);
    this.createColumns = this.createColumns.bind(this);
    this.onExportClick = this.onExportClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);

    this.state = {
      rqStartDate: moment().startOf('month').format('YYYY-MM-DD'),
      rqEndDate: moment().format('YYYY-MM-DD'),
      tablePage: 0,
      rowsPerPage: 30
    };
  }

  componentDidMount() {
    const self = this,
      { state: _state, props } = self,
      {
        dispatch = () => { }
      } = props,
      { 
        rqStartDate,
        rqEndDate,
        tablePage,
        rowsPerPage
      } = _state;
    
    let requestData = {
      start: rqStartDate,
      end: rqEndDate,
      pageIndex: tablePage + 1,
      pageSize: rowsPerPage
    };
    console.log(requestData);
    dispatch(search(requestData));
  }

  componentWillUnmount() {
     const self = this,
      { props } = self,
      { dispatch = () => { } } = props;
    
    dispatch(clearAccountList());
  }

  onExportClick() { 
    const self = this,
      {
        props,
        refs
      } = self,
      {
        dispatch = () => { }
      } = props,
      {
        startDate,
        endDate
      } = refs;
    
    let requestData = {
      start: moment(startDate.getValue().selectedDay).format('YYYY-MM-DD'),
      end: moment(endDate.getValue().selectedDay).format('YYYY-MM-DD'),
    };
    console.log(requestData)
    dispatch(getAccountBalancePDF(requestData));
  }

  onSearchClick() { 
    const self = this,
      {
        state: _state,
        props,
        refs } = self,
      {
        dispatch = () => { }
      } = props,
      {
        startDate,
        endDate
      } = refs,
      {
        rowsPerPage
      } = _state;
    
    let requestData = {
      start: moment(startDate.getValue().selectedDay).format('YYYY-MM-DD'),
      end: moment(endDate.getValue().selectedDay).format('YYYY-MM-DD'),
      pageIndex: 1,
      pageSize: rowsPerPage
    };
    
    this.setState({
      rqStartDate: moment(startDate.getValue().selectedDay).format('YYYY-MM-DD'),
      rqEndDate: moment(endDate.getValue().selectedDay).format('YYYY-MM-DD'),
      tablePage: 0
    });

    console.log(requestData)
    dispatch(search(requestData));
  }

  handlePageChange(pageData) { 
    const self = this,
      { state: _state, props } = self,
      {
        dispatch = () => { }
      } = props,
      { 
        rqStartDate,
        rqEndDate,
        rowsPerPage
      } = _state;
    
    let requestData = {
      start: rqStartDate,
      end: rqEndDate,
      pageIndex: pageData.selected + 1,
      pageSize: rowsPerPage
    };

    this.setState({
      tablePage: pageData.selected
    });
    console.log(requestData);
    dispatch(search(requestData));
  }

  createColumns() { 
    const accountColumns = [
    {
      //訂位代號
      id: 'pnr',
      label: i18n('pnr'),
      minWidth: 80,
      align: 'left',
    },
    {
      //連絡信箱
      id: 'email',
      label: i18n('contact_email'),
      minWidth: 90,
      align: 'left',
    },
    {
      //航段
      id: 'sector',
      label: i18n('flight_segment'),
      minWidth: 210,
      align: 'left',
      format: value => {
        return value ? (
          <div dangerouslySetInnerHTML={{ __html: value.replace(';', '<br/>') }}>
          </div>
          ) : null
      }
    },
    {
      //扣款金額/日期
      id: 'transcation_data',
      label: i18n('transcation_amount_date'),
      minWidth: 120,
      align: 'left',
      format: value => {
        return value ? (
          <div>
            <div>{value.currency} {Formatter.thousandComma(value.amt)}</div>
            <div style={{ fontSize: '12px', color: '#909090' }}>
              {moment(value.date).format('YYYY/MM/DD HH:mm:ss')}
            </div>
          </div>
          ) : null
      }
    },
    {
      //帳戶餘額
      id: 'balance',
      label: i18n('account_balance'),
      minWidth: 80,
      align: 'left',
      format: value => { 
        return value ? (
          <div style={{ fontWeight: 'bold' }}>{Formatter.thousandComma(value)}</div>
        ): null
      }
    }];
    
    return accountColumns;
  }

  render() {
    const self = this,
      {
        state: _state,
        props,
        onExportClick,
        onSearchClick,
        createColumns,
        handlePageChange
      } = self,
      {
        state,
        mainState,
      } = props,
      {
        searchResult,
        totalPageCount
      } = state,
      {
        balanceInfo
      } = mainState,
      {
        tablePage,
        rowsPerPage
      } = _state;
    
    return (
      <div className='account-container'>
        <div className='area-left'>
          <div className='account-title'>{i18n('account_list')}</div>
          <div className='account-body'>
            <div className='account-search-panel'>
              <div className='account-search-title'>
                {i18n('debited_date')}
                <Button
                  className={'primary-button account-export-btn'}
                  onClick={onExportClick}
                >
                  {i18n('export')}
                </Button>
              </div>
              <div className='account-search-row'>
                <DatePicker
                  ref='startDate'
                  type={'single'}
                  beforeSelect={moment().add(-10, 'y').toDate()}
                  defaultDate={moment().startOf('month').toDate()}
                  placeholder={'Start Date'}
                  selectedEvent={(day) => {}}
                />
                <DatePicker
                  ref='endDate'
                  type={'single'}
                  beforeSelect={moment().add(-10, 'y').toDate()}
                  placeholder={'End Date'}
                  defaultDate={moment().toDate()}
                  selectedEvent={(day) => {}}
                />
                <Button
                  className={'primary-button account-search-btn'}
                  onClick={onSearchClick}
                >
                  {i18n('search')}
                </Button>
              </div>
              {
                searchResult.length > 0 ? (
                  <div className='account-table'>
                    <Table
                      rows={searchResult}
                      columns={createColumns()}
                      tablePage={0}
                      rowsPerPage={rowsPerPage}
                      showPager={false}
                    />
                  </div>
                ) : null
              }
              {/* 使用自訂Pager */}
              <Pagination
                forcePage={tablePage ? tablePage : 0}
                pageCountProp={totalPageCount ? totalPageCount : 1}
                onPageChange={(data) => {
                  handlePageChange(data);
                }}
              />
            </div>
          </div>
            
        </div>
        <SideMenu
          balanceInfo={balanceInfo}
        />
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    state: state.accountReducer,
    mainState: state.mainReducer 
  };
};

export default connect(mapStateToProps)(AccountIndex);